import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";
import { useTranslation } from "react-i18next";

interface CompaniesSearchProps {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
}

export const CompaniesSearch = ({ 
  searchTerm, 
  setSearchTerm
}: CompaniesSearchProps) => {
  const { t } = useTranslation();
  return (
    <div className="mb-6 flex flex-col sm:flex-row gap-3">
      <div className="relative flex-1">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
        <Input 
          type="text"
          placeholder={t("companies.searchPlaceholder")}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="pl-10"
        />
      </div>
    </div>
  );
};
